import { getEnv } from '@ctct/ctct-helpers';

import type {
  PostSingleBillSetupElementRequest,
  PostSingleBillSetupElementResponse,
  SingleBillPayload,
} from './types/single-bill.types';
import { BaseApiClient } from '../BaseApiClient';

class BpConsoleApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/bpconsole`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getSingleBill() {
    return this.baseApiClient.get<unknown>('/customers/partner/singlebill');
  }

  public postSingleBill(body: SingleBillPayload) {
    return this.baseApiClient.post<unknown, unknown>('/customers/partner/singlebill/start', body);
  }

  public postSingleBillSetupElement(body: PostSingleBillSetupElementRequest) {
    return this.baseApiClient.post<PostSingleBillSetupElementResponse, PostSingleBillSetupElementRequest>(
      '/customers/partner/singlebill/setup-element',
      body
    );
  }

  public putSingleBill(body: SingleBillPayload) {
    return this.baseApiClient.put<unknown, unknown>('/customers/partner/singlebill', body);
  }

  public getPartner() {
    return this.baseApiClient.get<unknown>('/customers/partner');
  }
}

export const bpConsoleApi = new BpConsoleApi();

export type BpConsoleApiClient = typeof bpConsoleApi;
